import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedPrice } from "@jti/ui";
import styles from "./SummaryCartItemPrice.module.scss";
export const SummaryCartItemPrice = ({ price, isFreeTrial, currency }) => {
    return (_jsx("div", { children: !isFreeTrial && (_jsx("div", { className: styles.price, children: _jsx(FormattedPrice, { value: price, currency: currency }) })) }));
};
//# sourceMappingURL=SummaryCartItemPrice.js.map